import * as React from 'react';
import { fetchCountry } from '@gandi/redux-places';
import { jsx as _jsx } from "react/jsx-runtime";
class SubdivisionName extends React.Component {
  static preFetch(args) {
    if (args.country) {
      return args.dispatch(fetchCountry(args.country));
    }
    return Promise.resolve();
  }
  componentDidMount() {
    if (this.props.country && !this.props.isFetchingCountry && (!this.props.isLoadedCountry || this.props.isToRefetchCountry)) {
      this.props.fetchCountry(this.props.country);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.country && !nextProps.isFetchingCountry && (nextProps.country !== this.props.country || nextProps.isToRefetchCountry)) {
      this.props.fetchCountry(nextProps.country);
    }
  }
  render() {
    if (!this.props.subdivisionName) {
      return null;
    }
    return /*#__PURE__*/_jsx("span", {
      children: this.props.subdivisionName
    });
  }
}
export default SubdivisionName;